import {StandaloneHandler} from "../../common/handlers/standalone-handler";
import {Injectable} from "@angular/core";
import {HandleQuery} from "../../common/handlers/handle-query";
import {Observable, of} from "rxjs";
import {ErrorWithPointers} from "../../common/errors/errors";

@Injectable({
  providedIn: 'root'
})
export class AppHandler extends StandaloneHandler {

  @HandleQuery("getErrors")
  getErrors(): Observable<ErrorWithPointers[]> {
    return of(null);
  }
}
